import RoomsAcceptance from './container';
import { reducer } from './model';

export default RoomsAcceptance;
export { reducer };
